import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import partyIcon from "../../Assets/Icons/party.png";
import LoaderBox from "../HomePage/LoaderBox";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const FucaParty = () => {
  const [loading, setLoading] = useState(true);
  const [schedule, setSchedule] = useState([]);

  useEffect(() => {
    fetchPartyData();
  }, []);

  const fetchPartyData = async () => {
    try {
      const { data, error } = await supabase
        .from("party_settings")
        .select("party_schedule")
        .eq("id", 1)
        .maybeSingle();

      if (!error && data) {
        // --- POPRAVLJENO SORTIRANJE (Bez 'new' konstruktora) ---
        const sortedData = (data.party_schedule || []).sort((a, b) => {
          return String(a.date).localeCompare(String(b.date));
        });

        setSchedule(sortedData);
      }
    } catch (err) {
      console.error("Greška pri dohvaćanju party podataka:", err);
    } finally {
      setLoading(false);
    }
  };

  // Provjera je li događaj završio
  const isEventPast = (eventDate) => {
    if (!eventDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const evDate = new Date(eventDate);
    evDate.setHours(0, 0, 0, 0);
    return evDate < today;
  };

  // Formatiranje datuma: Dan, DD.MM.
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const weekday = date.toLocaleDateString("hr-HR", { weekday: "long" });
    const capitalizedWeekday =
      weekday.charAt(0).toUpperCase() + weekday.slice(1);

    const day = date.getDate();
    const month = date.getMonth() + 1;

    return `${capitalizedWeekday}, ${day}.${month}.`;
  };

  if (loading) return <LoaderBox text="Učitavanje..." />;

  const hasEvents = schedule.length > 0;

  return (
    <>
      <Navigation />
      <div className="fuca-party-wrapper">
        <div className="party-header">
          <img src={partyIcon} alt="Party" className="header-img" />
          <h3>Ostali događaji</h3>
        </div>

        {hasEvents ? (
          <div className="party-list">
            {schedule.map((item) => {
              const past = isEventPast(item.date);
              return (
                <div
                  key={item.id || item.date}
                  className={`party-card-full ${past ? "event-past" : ""}`}
                >
                  {/* Ikona kvačice u kutu za završene događaje */}
                  {past && (
                    <div className="past-corner-badge">
                      <i className="fi fi-rs-circle-check"></i>
                    </div>
                  )}

                  {/* Središnji tekst preko bluranog sadržaja */}
                  {past && (
                    <div className="past-center-text">Događaj završio</div>
                  )}

                  {/* Unutarnji kontejner koji se zamućuje ako je događaj prošao */}
                  <div className="event-card-user-inner">
                    <h2>{formatDate(item.date)}</h2>

                    <div className="performers-container">
                      {/* Naslov / Naziv događaja */}
                      <span className="event-main-title">{item.title}</span>

                      {/* Prikaz vremena stiliziran kao nekadašnji timeline */}
                      {item.showTime && item.startTime && (
                        <div className="event-user-time-row">
                          <span className="time-badge">
                            {item.startTime} - {item.endTime} h
                          </span>
                        </div>
                      )}

                      {/* Opis događaja */}
                      {item.description && (
                        <p className="event-user-desc">{item.description}</p>
                      )}
                    </div>
                  </div>

                  <div className="shimmer-line"></div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-party-container">
            <div className="party-card-empty">
              <h2>Trenutno nema zakazanih događaja</h2>
              <p>
                Pratite naše obavijesti! Uskoro objavljujemo detalje o zabavnom
                programu, hrani i piću nakon turnira.
              </p>
              <div className="shimmer-line"></div>
            </div>
          </div>
        )}
      </div>
      <HomeFooter />
    </>
  );
};

export default FucaParty;
